import useSWRImmutable from 'swr';

export default function usePATCH(path, body, axiosCfg, swrOpts) {
  const method = 'PATCH';

  let swrKey   = [path, method, body, axiosCfg];
  if (path == null)
    swrKey = null; //sending request conditionally

  return useSWRImmutable(swrKey, swrOpts);
}